import {useEffect} from "react";

export default function useMetaDescription(content: string) {
    useEffect(() => {
        document.querySelector('meta[name="description"]')?.setAttribute("content", content);
    }, [content]);

    return undefined
}
